// extracted by mini-css-extract-plugin
module.exports = {"root":"FormCard_root__92mct","form":"FormCard_form__2K-E0","actions":"FormCard_actions__1dHub"};